import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpeedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"speed"}/>
}
